<template>
    <div class='t_content_view'>
        <div class="t_search_box" style="margin-bottom: 20px">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">企微主体：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchform.corp_id" clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </div>
                <div class="t_search_select" >
                   
                    <el-input size="small" v-model="searchform.title" placeholder="请输入标题"  clearable />
                </div>
                <div class="t_search_select" >
                    <el-select
                        placeholder="请回复类型"
                        v-model="searchform.reply_type"
                        clearable 
                        size="small" 
                        style="width: 180px;"
                    >
                        <el-option
                        v-for="(item,index) in backtype.data"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                        />
                    </el-select>
                </div>
                <div class="t_search_select" >
                    <el-select
                        placeholder="请选择术语分组"
                        v-model="searchform.in_use" 
                        clearable 
                        size="small" 
                        style="width: 180px;"
                    >
                        <el-option
                        v-for="(item,index) in statetype.data"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                        />
                    </el-select>
                </div>
                
                <el-button color="#F1F3F9" type="primary" @click="searchbtn()" style="margin-bottom: 10px;">查询</el-button>
                <el-button color="#F1F3F9" type="primary" @click="openbackcon()" style="margin-bottom: 10px;">添加</el-button>
            </div>
  

        <el-table 
        :data="tableData.data" 
        style="width: 100%;margin-top: 20px;" 
        :header-cell-style="{backgroundColor:'#F1F3F9'}">
            
            <el-table-column prop="title" label="标题"  />
            <el-table-column prop="content" label="内容"  />
            <!-- <el-table-column prop="name" label="生效时间"  >
                <template #default="scope">
                    <div style="display: flex;align-items: center;">
                        <el-time-picker 
                        v-model="scope.row.startTime"
                        value-format="HH:mm:ss" 
                        @change="changestart($event,1,scope.row)"
                        placeholder="开始时间" />
                        <div style="margin-left: 10px;margin-right: 10px;color: #DDE0E7;">—</div>
                        <el-time-picker 
                        v-model="scope.row.endTime"
                        value-format="HH:mm:ss" 
                        @change="changestart($event,2,scope.row)"
                         placeholder="结束时间" />
                    </div>
                </template>
            </el-table-column> -->
            
            <el-table-column prop="address" label="是否启用" >
                <template #default="scope">
                    <div style="color:green" v-if="scope.row.in_use==1">启用</div>
                    <div style="color:red" v-else>禁用</div>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="回复类型" >
                <template #default="scope">
                    <div  v-if="scope.row.reply_type==1">在线回复</div>
                    <div  v-else>离线回复</div>
                </template>
            </el-table-column>
             <el-table-column prop="address" label="回复时间" >
                <template #default="scope">
                   <div>{{ scope.row.start_time }}-{{ scope.row.end_time }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" >
                <template #default="scope">
                    <div class="t_key_arr_box">
                        
                        <!-- <div  @click="openbackcon(scope.row)" class="t_edit_icon">修改</div> -->
                        <el-button style="color:#4F46E5"  type="text" @click="openbackcon(scope.row)">修改</el-button>
                        <el-button style="color:#4F46E5"  type="text" @click="delbtn(scope.row.id)">删除</el-button>
                        
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchform.page" @page_change="page_change" />
    
    
     
    </div>
 
    <!-- 欢迎话术 -->
    <el-dialog
        v-model="isshowkeyback"
        title="回复模版"
        width="500px">
        <el-input v-model="addform.title" style="margin-bottom: 20px;" placeholder="标题"  clearable />
        <el-input
            :rows="10"
            type="textarea"
            placeholder="输入回复话术"
            v-model="addform.content"
         clearable />
        
        <div style="margin-top: 20px;margin-bottom: 20px;">
            是否启用：
            <el-switch
            v-model="addform.in_use"
            :active-value="1"
            :inactive-value="0"
        />
        </div>
        <el-select
            v-model="addform.reply_type"
            placeholder="回复类型"
          
            >
            <el-option
                v-for="(item,index) in backtype.data"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
        </el-select>
        <el-select  style="margin-top: 10px;" v-model="addform.corp_id" clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
        </el-select>
        <div style="display: flex;align-items: center;margin-top: 20px;">
            <el-time-picker 
            v-model="addform.start_time"
            value-format="HH:mm:ss" 
            placeholder="开始时间" />
            <div style="margin-left: 10px;margin-right: 10px;color: #DDE0E7;">—</div>
            <el-time-picker 
            v-model="addform.end_time"
            value-format="HH:mm:ss" 
                placeholder="结束时间" />
        </div>
        <div class="t_dig_btn_box">
            <el-button @click="isshowkeyback = false">取消</el-button>
            <el-button @click="addbackcon" color="#4F46E5" type="primary">确认添加</el-button>
        </div>
    </el-dialog>
 
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload ,Plus ,Close} from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { onoroutline,editonoroutline,newgetcallbacklist,newcreatecallback,neweditcallback,newdelcallback,newgetcomp2} from '@/assets/js/common.js'
//获取路由参数 
const route = useRoute()
//路由跳转
const router = useRouter()

//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    getlist()
    //获取企微主体下拉
    getcorplist()
})

//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}
//回复类型
const backtype = reactive({
    data:[
        {
            label:'在线回复',
            value:1,
        },
        {
            label:'离线回复',
            value:0,
        }
    ]
})

//回复类型
const statetype = reactive({
    data:[
        {
            label:'启用',
            value:1,
        },
        {
            label:'禁用',
            value:0,
        }
    ]
})

//列表数据
const tableData = reactive({
    data:[]
})



//是否显示编辑欢迎话术
const isshowkeyback = ref(false)

//当前选择
const nowchoose = reactive({
    data:{}
})

//数据
const addform = reactive({
    id:'',
    title:'',
    content:'',
    in_use:1,
    reply_type:'',
    start_time:'',
    end_time:'',
    corp_id:''
})

//编辑欢迎话术
const openbackcon = (row)=>{
    if(row){
        //编辑
        nowchoose.data = row
        addform.id = row.id
        addform.title = row.title
        addform.content = row.content
        addform.in_use = row.in_use
        addform.reply_type = row.reply_type
        addform.start_time = row.start_time
        addform.end_time = row.end_time
        addform.corp_id = row.corp_id
    }else{
        //新增
        addform.id = ''
        addform.title = ''
        addform.content = ''
        addform.in_use = 1
        addform.reply_type = '' 
        addform.start_time = '' 
        addform.end_time = '' 
        addform.corp_id = ''
    }
    
    
    
    
    isshowkeyback.value = true
}

//欢迎话术
const hellomsg = ref('')
//添加欢迎话术
const addbackcon = ()=>{
    console.log(addform)
   if(addform.id){
    //编辑
    neweditcallback(addform).then((response)=>{
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '操作成功',
                type: 'success',
            })
            getlist()
            isshowkeyback.value = false
        }
    })
   }else{
    //新增
    newcreatecallback(addform).then((response)=>{
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '操作成功',
                type: 'success',
            })
            getlist()
            isshowkeyback.value = false
        }
    })
   }
    
    
}

//搜索
const searchform = reactive({
    page:1,
    page_size:20,
    title:'',
    in_use:'',
    reply_type:'',
    corp_id:''
})

//搜索
const searchbtn = ()=>{
    searchform.page=1
    getlist()
}


//总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchform.page = val
    //人员列表
    getlist()
}
//获取列表
const getlist = ()=>{
    newgetcallbacklist(searchform).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log('售前列表')
            console.log(response.data)
            tableData.data = response.data.data.data
            total.value = response.data.data.total
        }
    })
}

//修改时间
const changestart = ($event,type,row)=>{
    console.log('修改时间')
    console.log($event)
    console.log(type)
    console.log(row)

    if(type==1){
        //开始时间
        if($event){
            var obj = {
                id:row.id,
                startTime:$event,
            }
        }else{
            var obj = {
                id:row.id,
                startTime:'00:00:00',
            }
        }
        
    }else{
        //结束时间
        if($event){
            var obj = {
                id:row.id,
                endTime:$event,
            }
        }else{
            var obj = {
                id:row.id,
                endTime:'00:00:00',
            }
        }
        
    }

    editonoroutline(_url2,obj).then((response)=>{
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '操作成功',
                type: 'success',
            })
            getlist()
        }
    })
}

//修改启用
const changeuse = ($event,row)=>{
    console.log('是否启用')
    console.log($event)
    console.log(row)
    editonoroutline(_url2,{
        id:row.id,
        isUse:$event
    }).then((response)=>{
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '操作成功',
                type: 'success',
            })
            getlist()
        }
    })
}

//删除
const delbtn = (id)=>{
    ElMessageBox.confirm(
    '是否确认删除',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelcallback({id:id}).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                
                getlist()
            }
            
        })
      
    }).catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}


const convertNewLinesToBr = (text)=> {
    return text.replace(/\n/g, '<br>');
  }


</script>
<style scoped>

.t_autokeyword_box{
    padding: 30px;
    box-sizing: border-box;
    background-color: white;
   }
   .t_auto_search_box{
    display: flex;
    align-items: center;
    background-color: #F6F8FB;
    border-radius: 8px;
    border: 1px solid #e3e8f1;
    width: 280px;
    font-size: 15px;
   }
   .t_auto_input{
    width: 240px;
   }
   :deep(.t_auto_input .el-input__wrapper){
    background-color:#F6F8FB ;
    box-shadow: none;
   }
   .t_key_arr_box{
    display: flex;
    flex-wrap: wrap;
   }
   .t_key_arr_item{
    border-radius: 4px;
    background: #f7f8fa;
    padding: 2px 10px;
    margin-right: 10px;
   }
   .t_edit_icon{
    color: #4F46E5;
    cursor: pointer;
   }
   .t_del_btn{
    color: #4F46E5;
    cursor: pointer;
   }
   .t_cz_box{
    display: flex;
    justify-content: center;
    margin-top: 50px;
    padding-bottom: 50px;
    
   }
   :deep(.el-table .el-table__cell){
    padding: 15px 0;
   }
   .t_dig_btn_box{
    margin-top: 20px;
    display: flex;
    justify-content: end;
   }
   .t_keywords_item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #666666;
   }
   .t_key_del{
    cursor: pointer;
    color: #4F46E5;
   }
   .t_key_title_box{
    display:flex;
    align-items: center;
    margin-bottom: 15px;
   }
   .t_key_title_font{
    margin-right: 20px;
    color: #333333;
    font-size: 19px;
   }
   .t_key_dig_con{
    padding: 0px 10px 10px 10px;
    box-sizing: border-box;
   }
   :deep(.t_key_input .el-input__wrapper){
    background-color: #F6F8FB;
   }
   :deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>